import React from 'react'
import { Mode } from './constants'
import MoogSirinUI from "./MoogSirin"
import MIDISequencer from './MIDISequencer'
import VideoChatRemote from './VideoChatRemote'
import MIDIControlPanel from './MIDIControlPanel'
import { MIDIProvider } from './contexts/MIDIContext'
import { WebRTCProvider } from './contexts/WebRTCContext'

export default function Remote() {
  return (
    <div>
      <WebRTCProvider>
        <VideoChatRemote />
        <MIDIProvider>
          <MIDIControlPanel showOutput={false} mode={Mode.REMOTE} />
          <MIDISequencer />
          <MoogSirinUI />
        </MIDIProvider>
      </WebRTCProvider>
    </div >
  );
}
